// extracted by mini-css-extract-plugin
export default {"regexInputContainer":"DefinitionRegexEditor-module__regexInputContainer__tY06eUO","testRegexButton":"DefinitionRegexEditor-module__testRegexButton__xHPVABw"};